import React from "react";

const Pagination = ({ currentPage = 1, totalCount = 0, onPageChange }) => {
  const itemsPerPage = 8;
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  const start = totalCount === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const end = Math.min(currentPage * itemsPerPage, totalCount);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row justify-between p-4 items-center">
      <div>
        <p className="text-sm sm:text-base">
          Shfaqur {start} - {end} nga {totalCount}
        </p>
      </div>

      <div className="flex gap-2 sm:gap-1">
        <button
          className="w-[80px] sm:w-[110px] py-1 bg-[#FFB526] rounded text-white text-xs sm:text-sm"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Pas
        </button>

        <button
          className="w-[80px] sm:w-[110px] py-1 bg-[#FFB526] rounded text-white text-xs sm:text-sm"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Para
        </button>
      </div>
    </div>
  );
};

export default Pagination;
